<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ $t('labels.hired') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :default-sort="placementsTable.defaultSort"
                                    :excel="false"
                                    :fields="placementsTable.headers"
                                    :total-records="placementsTable.total"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                    height="300px"
                                    :showFooter="true"
                                    :showIcons="true"
                                >
                                    <tr
                                        v-for="(item, key) in placementsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('seafarer')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.seafarer_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('rank')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.rank_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('vessel')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.vessel_types_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('status')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.status_display }}
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'VacancyPlacements',
    components: {TheTable},
    data: function () {
        return {
            placementsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.seafarer'), value: 'seafarer', type: '', sortable: false},
                    {text: this.$t('fields.rank'), value: 'rank', type: '', sortable: false},
                    {text: this.$t('fields.vesselExpirience'), value: 'vessel', type: '', sortable: false},
                    {text: this.$t('fields.status'), value: 'status', type: '', sortable: false},

                    {
                        text: '',
                        value: 'actions',
                        type: '',
                        sortable: false,
                        width: '20px',
                        allowFilter: false,
                    },
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
        };
    },
    props: ['vacancy'],
    methods: {
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/placements/' + id);
            } else {
                let routeData = this.$router.resolve('/placements/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.placementsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'vacancy-placements/' + this.vacancy.id,
                request,
                (data, success) => {
                    if (success) {
                        vm.placementsTable.items = data.items;
                        vm.placementsTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
    },
};
</script>

<style scoped></style>
